module.exports = __webpack_public_path__ + "img/scc-team-temp.82b3f2af.jpg";